/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { useEffect } from 'react'

declare global {
    interface Window {
        handleIFrameMessage?: (e: MessageEvent) => void
        isPermitted?: (originUrl: string, whitelisted_domains: string[]) => boolean
    }
}
const iframeProps = {
    allowtransparency: 'true',
    allowFullScreen: true,
    allow: 'geolocation; microphone; camera',
    src: 'https://form.jotform.com/232882527684468',
    frameBorder: '0',
    style: { minWidth: '100%', maxWidth: '100%', height: '539px', border: 'none' },
    scrolling: 'no',
    className: 'jotformIframeContainer',
    id: 'JotFormIFrame-232882527684468',
    title: 'War Tips',
}

function hasMozCancelFullScreen(
    doc: Document,
): doc is Document & { mozCancelFullScreen: () => Promise<void> } {
    return 'mozCancelFullScreen' in doc
}

function hasWebkitExitFullscreen(
    doc: Document,
): doc is Document & { webkitExitFullscreen: () => Promise<void> } {
    return 'webkitExitFullscreen' in doc
}

function hasMsExitFullscreen(
    doc: Document,
): doc is Document & { msExitFullscreen: () => Promise<void> } {
    return 'msExitFullscreen' in doc
}

export const ContactUs = () => {
    useEffect(() => {
        const ifr = document.getElementById('JotFormIFrame-232882527684468') as HTMLIFrameElement | null
        if (ifr) {
            let src = ifr.src
            let iframeParams: string[] = []
            if (window.location.href.indexOf('?') > -1) {
                iframeParams = iframeParams.concat(
                    window.location.href.substr(window.location.href.indexOf('?') + 1).split('&'),
                )
            }
            if (src.indexOf('?') > -1) {
                iframeParams = iframeParams.concat(src.substr(src.indexOf('?') + 1).split('&'))
                src = src.substr(0, src.indexOf('?'))
            }
            iframeParams.push('isIframeEmbed=1')
            ifr.src = `${src}?${iframeParams.join('&')}`
        }

        window.handleIFrameMessage = function (e) {
            if (typeof e.data === 'object') {
                return
            }
            const args = e.data.split(':')
            let iframe: HTMLElement | null
            if (args.length > 2) {
                iframe = document.getElementById(`JotFormIFrame-${args[args.length - 1]}`)
            } else {
                iframe = document.getElementById('JotFormIFrame')
            }
            if (!iframe) return
            switch (args[0]) {
                case 'scrollIntoView':
                    iframe.scrollIntoView()
                    break
                case 'setHeight':
                    ; (iframe as HTMLIFrameElement).style.height = args[1] + 'px'
                    break
                case 'collapseErrorPage':
                    if ((iframe as HTMLIFrameElement).clientHeight > window.innerHeight) {
                        ; (iframe as HTMLIFrameElement).style.height = window.innerHeight + 'px'
                    }
                    break
                case 'reloadPage':
                    window.location.reload()
                    break
                case 'loadScript':
                    if (
                        !window.isPermitted ||
                        !window.isPermitted(e.origin, ['jotform.com', 'jotform.pro'])
                    ) {
                        break
                    }
                    let src = args[1]
                    if (args.length > 3) {
                        src = args[1] + ':' + args[2]
                    }
                    const script = document.createElement('script')
                    script.src = src
                    script.type = 'text/javascript'
                    document.body.appendChild(script)
                    break
                case 'exitFullscreen':
                    if (document.exitFullscreen) {
                        document.exitFullscreen()
                    } else if (hasMozCancelFullScreen(document)) {
                        document.mozCancelFullScreen()
                    } else if (hasWebkitExitFullscreen(document)) {
                        document.webkitExitFullscreen()
                    } else if (hasMsExitFullscreen(document)) {
                        document.msExitFullscreen()
                    }
                    break
            }
        }

        window.isPermitted = function (originUrl, whitelisted_domains) {
            const url = document.createElement('a')
            url.href = originUrl
            const hostname = url.hostname
            return whitelisted_domains.some(
                (element) => hostname.endsWith(`.${element}`) || hostname === element,
            )
        }

        if (window.addEventListener) {
            window.addEventListener('message', window.handleIFrameMessage, false)
        } else if ((window as any).attachEvent) {
            ; (window as any).attachEvent('onmessage', window.handleIFrameMessage)
        }

        return () => {
            window.removeEventListener('message', window.handleIFrameMessage!)
        }
    }, [])

    return (
        <div className="min-h-4xl">
            <iframe {...iframeProps}></iframe>
        </div>
    )
}

export default ContactUs